import { selecetedShopIdActionTypes } from './selected-shop-id-reducer';

export enum termsReducerActionTypes {
  UPDATE_TERMS_CHECKED = 'TERMS_UPDATE_TERMS_CHECKED',
  UPDATE_NEWSLETTER_SUBSCRIBED = 'TERMS_UPDATE_NEWSLETTER_SUBSCRIBED',
}

interface TermsUpdateTermsCheckedAction {
  type: termsReducerActionTypes.UPDATE_TERMS_CHECKED;
  payload: boolean;
}

interface TermsUpdateNewsletterSubscribedAction {
  type: termsReducerActionTypes.UPDATE_NEWSLETTER_SUBSCRIBED;
  payload: boolean | null;
}

interface SelectedShopIdAction {
  type: selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE;
  payload: string;
}

export type TermsReducerAction =
  | TermsUpdateTermsCheckedAction
  | TermsUpdateNewsletterSubscribedAction
  | SelectedShopIdAction;

export interface TermsReducerState {
  termsChecked: boolean;
  newsletterSubscribed: boolean | null;
}

export const termsReducerInitialState: TermsReducerState = {
  termsChecked: false,
  newsletterSubscribed: null,
};

const termsReducer = (
  state: TermsReducerState,
  action: TermsReducerAction
): TermsReducerState => {
  switch (action.type) {
    case termsReducerActionTypes.UPDATE_TERMS_CHECKED: {
      return {
        ...state,
        termsChecked: action.payload,
      };
    }
    case termsReducerActionTypes.UPDATE_NEWSLETTER_SUBSCRIBED: {
      return {
        ...state,
        newsletterSubscribed: action.payload,
      };
    }
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return termsReducerInitialState;
    }
    default: {
      return state;
    }
  }
};

export default termsReducer;
